import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { formatDecimal, rupiah } from 'utils/formatter';
import WarningMessage from 'components/WarningMessage';
import _sortBy from 'lodash/sortBy';
import styles from './Review.css';
import RewardList from '../RewardList';
import GainPointList from '../RewardList/GainPointList';
import { MOBILE_APP_VERSION_WARNING } from '../../constants';

class ReviewInfo extends Component {
  render() {
    const {
      earningRuleType,
      pointFromSpendingAmount,
      pointFromBuyingItem,
      rewards,
      spendingAmount,
      newMemberPoint,
      sentValidationCode,
    } = this.props;
    const formattedNewMemberPoint =
      newMemberPoint !== '' ? formatDecimal(newMemberPoint) : 0;
    const formattedPointFromSpendingAmount =
      pointFromSpendingAmount !== ''
        ? formatDecimal(pointFromSpendingAmount)
        : 0;
    const formattedPointFromBuyingItem =
      pointFromBuyingItem !== '' ? formatDecimal(pointFromBuyingItem) : 0;

    const sortedRewards = _sortBy(rewards, ['point']);
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className={styles['section-label']}>
              Confirm Loyalty Program
            </div>
            {earningRuleType === 'ITEM' && (
              <div className={styles['earning-rule-details']}>
                <div className={`col-md-1 ${styles['earning-rule-image']}`}>
                  <img src={require('assets/images/groceries.png')} />
                </div>
                <div className="col-md-6">
                  <div>
                    <b>
                      Gain points from buying item
                      {this.props.itemRules[0] &&
                        this.props.itemRules[0].type === 'CATEGORY' && (
                          <span>s in a category</span>
                        )}
                    </b>
                  </div>
                  <div>
                    <i>New members gain {formattedNewMemberPoint} point(s)</i>
                  </div>
                </div>
                <div
                  className="col-md-5"
                  style={{ paddingRight: '1px', float: 'right' }}
                >
                  <WarningMessage
                    message={MOBILE_APP_VERSION_WARNING}
                    iconStyle={`circle`}
                  />
                </div>
              </div>
            )}
            {earningRuleType === 'SPENDING' && (
              <div className={styles['earning-rule-details']}>
                <div
                  className={`col-md-1 ${styles['earning-rule-image']}`}
                  style={{ paddingTop: '3px' }}
                >
                  <img src={require('assets/images/rp.png')} />
                </div>
                <div className="col-md-10">
                  <div>
                    <b>Gain points from total Rp. spent</b>
                  </div>
                  <div style={{ paddingTop: '3px', paddingBottom: '3px' }}>
                    <i>New members gain {formattedNewMemberPoint} point(s) </i>
                  </div>
                  <div>
                    Point rule: Members gain {formattedPointFromSpendingAmount}{' '}
                    points for every {rupiah(spendingAmount)} spent
                  </div>
                </div>
              </div>
            )}
            {earningRuleType === 'ITEM' && (
              <div>
                <div
                  style={{
                    paddingLeft: '0px',
                    paddingTop: '0px',
                    paddingBottom: '10px',
                  }}
                >
                  Point rule: Members gain {formattedPointFromBuyingItem}{' '}
                  {this.props.itemRules[0] &&
                  this.props.itemRules[0].type === 'CATEGORY' ? (
                    <span>
                      {' '}
                      point(s) from items in the following categories:
                    </span>
                  ) : (
                    <span> point(s) from the following items:</span>
                  )}
                </div>
                <GainPointList itemRules={this._toDisplayGainPoints()} />
              </div>
            )}
          </div>
        </div>
        <div className="row top30">
          <div className="col-md-12">
            <div className={styles['section-label']}>Reward List</div>
            <RewardList rewards={sortedRewards} />
          </div>
        </div>
        <div className="row top30">
          <div className="col-md-12">
            <div
              className={styles['section-label']}
              style={{ marginBottom: '10px' }}
            >
              Program Configuration
            </div>
            <div className={styles['program-info']}>
              <span className={styles['program-info-chosen']}>
                No expiry date, until deactivated manually
              </span>
            </div>
            <div className={styles['program-info']}>
              <span className={styles['program-info-chosen']}>
                {sentValidationCode
                  ? 'Use SMS validation code for every reward redemption'
                  : 'Do not use SMS validation code for reward redemptions'}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _toDisplayGainPoints = () => {
    const items = [];
    if (this.props.earningRuleType === 'ITEM' && this.props.itemRules) {
      this.props.itemRules.forEach(element => {
        items.push({
          type: element.type,
          itemName: element.item_name,
          categoryName: element.category_name,
          itemVariantNames: element.item_variant_names,
          point: this.props.pointFromBuyingItem,
        });
      });
    }
    return _sortBy(items, ['point']);
  };
}

ReviewInfo.propTypes = {
  pointFromSpendingAmount: PropTypes.array.isRequired,
  rewards: PropTypes.array,
  spendingAmount: PropTypes.number,
  newMemberPoint: PropTypes.number,
};

export default ReviewInfo;
